import type { TopikLevel } from './types'

/** 뱃지 색상 규칙: 1–2급 초록 / 3–4급 파랑 / 5–6급 앰버 */
export function badgeClass(level: TopikLevel): string {
  if (level <= 2) return 'badge badge--lv12'
  if (level <= 4) return 'badge badge--lv34'
  return 'badge badge--lv56'
}

export function levelLabel(level: TopikLevel): string {
  return `TOPIK ${level}급`
}

export function levelBand(level: TopikLevel): '초급' | '중급' | '고급' {
  if (level <= 2) return '초급'
  if (level <= 4) return '중급'
  return '고급'
}

export function levelBandEn(level: TopikLevel): string {
  if (level <= 2) return 'Beginner'
  if (level <= 4) return 'Intermediate'
  return 'Advanced'
}

export function clampLevel(n: number): TopikLevel {
  return Math.min(6, Math.max(1, Math.round(n))) as TopikLevel
}

/**
 * 큐레이션 정렬 — 내 급수에 가까운 순.
 *
 * 예전에는 급수 ±1 로 목록을 **걸렀다**. 그러면 맞춤형이 되는 대신 나머지 영상이
 * 아예 보이지 않아, 보고 싶은 영상을 못 찾는 쪽이 더 큰 손해였다.
 * 지금은 전부 보여주되 내 급수에 가까운 것을 위로 올린다.
 */
export function curationDistance(videoLevel: TopikLevel, userLevel: TopikLevel): number {
  return Math.abs(videoLevel - userLevel)
}

export const GENRE_LABELS: Record<string, string> = {
  kpop: 'K-pop',
  drama: '드라마',
  variety: '예능',
  news: '뉴스',
}
